import { sessionExpiredResponse } from './responses/sessionExpiredResponse';
import { loginFailureResponse } from './responses/loginFailureResponse';
import { unauthorizedResponse } from './responses/unauthorizedResponse';

export interface ErrorResponse {
  code: number;
  reason: string;
  message: string;
  detail?: {
    errorCode: string;
  };
}

export const createSessionExpiredResponse = (): ErrorResponse => sessionExpiredResponse;
export const createLoginFailureResponse = (): ErrorResponse => loginFailureResponse;
export const createUnauthorizedResponse = (): ErrorResponse => unauthorizedResponse;
